import { render, staticRenderFns } from "./NextStepSlot.vue?vue&type=template&id=2290ed70&scoped=true&"
import script from "./NextStepSlot.vue?vue&type=script&lang=js&"
export * from "./NextStepSlot.vue?vue&type=script&lang=js&"
import style0 from "./NextStepSlot.vue?vue&type=style&index=0&id=2290ed70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2290ed70",
  null
  
)

export default component.exports